export default __webpack_public_path__ + "static/media/light-unknown.8ab1df35.png";